export const formatKm = (value: number | string | null | undefined): string => {
	if (value === null || value === undefined || value === '') return '';

	return Number(value).toLocaleString('pt-BR');
};
